
































































import { ColorEnum, DeviceEnum } from '../enums';

import { UiIconButton } from './';
import Badge from './badge.component.vue';

enum MarkerTypeEnum {
  SOLID = 'solid',
  LABEL = 'label',
}

export default {
  name: 'epb-slider',
  components: {
    Badge,
    UiIconButton
  },
  computed: {
    steps: function () {
      return ((this.max - this.min) - 1) / this.step;
    },
    fillStyle: function () {
      const deltax = !!this.localValue ? this.relativeValue(this.localValue) : 0;
      return { transform: `scaleX(${ deltax })` };
    },
    markerContainerStyle: function () {
      return {
        width: `${ 100 / (this.max - this.min) }%`,
        transform: `translateX(${ (this.localValue - this.min) * 100 }%)`
      };
    },
    markerText: function (): string {
      return this.markerValue === undefined ? this.localValue : this.markerValue[this.localValue];
    },
    sliderTrackHooks: function () {
      return {
        mousedown: this.onDragStart,
        mouseup: this.onDragStop,
        touchstart: this.onDragStart,
        touchend: this.onDragStop
      };
    }
  },
  props: {
    tabindex: Number,
    color: {
      type: String,
      default: ColorEnum.BLACK
    },
    value: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    step: {
      type: Number,
      default: 1
    },
    markerType: {
      type: String,
      default: MarkerTypeEnum.SOLID
    },
    stepsMarker: {
      type: Boolean,
      default: false
    },
    showBadge: {
      type: Boolean,
      default: true
    },
    markerValue: Array,
    disabled: {
      type: Boolean,
      default: false
    },
    label: String,
    help: String
  },
  data: function () {
    return {
      isActive: false,
      isDragging: false,
      trackOffset: 0,
      localValue: this.value,
      scrollTimeout: {},
      isDraggable: true,
      isScrolling: false,
      DeviceEnum,
      MarkerTypeEnum,
      ColorEnum
    };
  },
  methods: {
    onFocus: function (): void {
      this.isActive = true;
      this.$emit('focus');
    },
    onBlur: function (): void {
      this.isActive = false;
      this.$emit('blur');
    },
    onExternalClick: function (event): void {
      if (!this.$el.contains(event.target)) {
        this.onBlur();
      }
    },
    setValueWithSnap: function (value: number): void {
      value = this.getEdge(value);
      this.setValue(value);
    },
    setValue: function (value: number): void {
      value = this.getEdge(value);
      if (value !== this.localValue) {
        this.localValue = value;
        const emittedValue = (!!this.markerValue ? this.markerValue[value] : value);
        this.$emit('input', emittedValue);
        this.$emit('change', emittedValue);
      }
    },
    incrementValue: function (): void {
      this.setValueWithSnap(this.localValue + this.step);
    },
    decrementValue: function (): void {
      this.setValueWithSnap(this.localValue - this.step);
    },
    onDragStart: function (): void {
      if (this.disabled) {
        return;
      }
      if (!this.isActive && !this.isScrolling) {
        this.onFocus();
      }
      if (this.isDraggable && !this.disabled && !this.isScrolling) {
        this.isDragging = true;
        this.dragUpdate(event);
        document.addEventListener('touchmove', this.dragUpdate);
        document.addEventListener('mousemove', this.dragUpdate);
        this.$emit('dragstart', this.localValue, event);
      }
    },
    getElementOffset: function (elementRef: string): number {
      let element = this.$refs[elementRef];
      let offset = element.offsetLeft;
      while (element.offsetParent) {
        element = element.offsetParent;
        offset += element.offsetLeft;
      }
      return offset;
    },
    dragUpdate: function (event): void {
      const position = event.touches ? event.touches[0].pageX : event.pageX;
      const relativeValue = (position - this.trackOffset) / this.$refs.track.offsetWidth;
      const value = this.getEdge(this.min + (relativeValue * (this.max - this.min)));
      if (this.isDragging) {
        this.setValue(Math.round(value / this.step) * this.step);
      }
    },
    onDragStop: function (event): void {
      if (this.isDragging) {
        this.isDragging = false;
        if (this.snapToSteps && (this.value % this.step !== 0)) {
          this.setValueWithSnap(this.value);
        }
        ['touchmove', 'mousemove'].forEach((e) => document.removeEventListener(e, this.dragUpdate));
        this.$emit('dragend', this.localValue, event);
      }
    },
    onScroll: function (): void {
      this.isDraggable = false;
      this.isScrolling = true;
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.isDraggable = true;
        this.isScrolling = false;
      }, 500);
    },
    relativeValue: function (value: number): number {
      return !!value ? (value - this.min) / (this.max - this.min) : 0;
    },
    getEdge: function (value: number): number {
      if (value < this.min) {
        return this.min;
      }
      if (value > this.max) {
        return this.max;
      }
      return value;
    }
  },
  watch: {
    value: function (): void {
      this.setValue(this.value);
    }
  },
  mounted: function () {
    ['touchend', 'mouseup'].forEach((event) => document.addEventListener(event, this.onDragStop));
    window.addEventListener('scroll', this.onScroll);
    document.addEventListener('click', this.onExternalClick);
    this.trackOffset = this.getElementOffset('track');
    this.setValue(this.getEdge(this.localValue ? this.localValue : 0));
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.onScroll);
    ['touchend', 'mouseup'].forEach((event) => document.removeEventListener(event, this.onDragStop));
    document.removeEventListener('click', this.onExternalClick);
  }
};
